<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "reset" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 18 18'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M3 5.25H10.5C12.9853 5.25 15 7.26472 15 9.75C15 12.2353 12.9853 14.25 10.5 14.25H3M3 5.25L6 2.25M3 5.25L6 8.25'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>